import { useQuery } from "@tanstack/react-query";
import axios from "./axios";

export type StatusDistribution = {
  status: string; // O | A | F | W
  label: string;
  count: number;
};

export type BrandDistribution = { brand: string; count: number };
export type EnergyType = "thermal" | "hybrid" | "electric";
export type EnergyDistribution = { type: EnergyType; count: number; percentage: number };
export type SinisterStatus = { status: string; count: number };
export type SinisterTrendPoint = { month: string; ym: string; count: number };

export type DashboardKpis = {
  totalVehicles: number;
  assigned: number;
  free: number;
  ordered: number;
  waiting: number;
  collaborators: number;
  activeCollaborators: number;
  openSinisters: number;
  monthlyFleetCost: number;
  utilizationRate: number;
};

export type DashboardAnalytics = {
  range: number;
  generatedAt: string;
  kpis: DashboardKpis;
  statusDistribution: StatusDistribution[];
  brandDistribution: BrandDistribution[];
  energyDistribution: EnergyDistribution[];
  sinisterStatus: SinisterStatus[];
  sinisterTrend: SinisterTrendPoint[];
  sinisterDelta: number;
};

export const DashboardKeys = {
  analytics: (fleetId: number, range: number) =>
    ["dashboard-analytics", "idFleet", fleetId, "range", range] as const,
};

export const useGetDashboardAnalytics = (fleetId: number, range = 6) => {
  const { data, error, ...res } = useQuery({
    queryKey: DashboardKeys.analytics(fleetId, range),
    enabled: !!fleetId,
    queryFn: async (): Promise<DashboardAnalytics> => {
      const response = await axios.get(
        `/companies/${fleetId}/dashboard/analytics`,
        { params: { range } }
      );
      return response?.data;
    },
  });

  return { analytics: data, error, ...res };
};
